import { render, staticRenderFns } from "./redirecter.vue?vue&type=template&id=0e617d63&"
import script from "./redirecter.vue?vue&type=script&lang=ts&"
export * from "./redirecter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports